import React from "react";
import { Instagram, Youtube, Facebook, Music2 } from "lucide-react";

export function TikTokIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16.5 3c.3 2.1 1.6 3.7 3.7 4v2.3c-1.3 0-2.6-.4-3.7-1.1v6.2c0 3.2-2.6 5.8-5.8 5.8S4.9 17.6 4.9 14.4s2.6-5.8 5.8-5.8c.3 0 .6 0 .9.1v2.5c-.3-.1-.6-.2-.9-.2-1.8 0-3.2 1.5-3.2 3.3s1.4 3.3 3.2 3.3 3.2-1.5 3.2-3.3V3h2.6z" />
    </svg>
  );
}

export const SOCIAL_KEYS = [
  ["instagram", "Instagram", Instagram],
  ["tiktok", "TikTok", TikTokIcon],
  ["youtube", "YouTube", Youtube],
  ["facebook", "Facebook", Facebook],
  ["spotify", "Spotify", Music2],
];

export const AGENCY_SOCIALS = {
  instagram: "https://www.instagram.com/sily.224",
  tiktok: "https://www.tiktok.com/@sily.agency",
  youtube: "https://youtube.com/@silyagency",
  facebook: "https://www.facebook.com/share/1MxNKsD7tv/",
};

export function SocialLinks({ links, owner, prefix, className = "", itemClass, showLabel = false }) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {SOCIAL_KEYS.filter(([k]) => links?.[k]).map(([k, label, Icon]) => (
        <a key={k} href={links[k]} target="_blank" rel="noopener noreferrer" aria-label={`${owner} ${label}`} title={`${owner} · ${label}`}
           data-testid={`${prefix}-${k}`} className={itemClass}>
          <Icon className="w-4 h-4 shrink-0" />
          {showLabel && <span>{label}</span>}
        </a>
      ))}
    </div>
  );
}
